// extracted by mini-css-extract-plugin
export default {"left_box":"index_left_box_S81yK","dbox":"index_dbox_kfbGP"};